var React = require('react');

function ArrowUpRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;}")),React.createElement("title",{"key":1},"arrow--up-right"),React.createElement("polygon",{"points":"10 6 10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6","key":2}),React.createElement("rect",{"id":"_Transparent_Rectangle_","data-name":"<Transparent Rectangle>","className":"cls-1","width":"32","height":"32","key":3})]);
}

ArrowUpRight.defaultProps = {"id":"icon","viewBox":"0 0 32 32"};

module.exports = ArrowUpRight;

ArrowUpRight.default = ArrowUpRight;
